import ShModel from './sh-model';
import { belongsTo, attr } from '@ember-data/model';

const PAYMENT_METHODS = {
  ACH: 'ach',
  CHECK: 'check',
  WIRE: 'wire',
};

const PAYMENT_METHOD_NAMES = {
  [PAYMENT_METHODS.ACH]: 'ACH',
  [PAYMENT_METHODS.CHECK]: 'Check',
  [PAYMENT_METHODS.WIRE]: 'Wire',
};

export const SH_GENERAL_INVOICE_TRANSACTION = {
  PAYMENT_METHODS,
  PAYMENT_METHOD_NAMES,
};

export default class ShGeneralInvoice extends ShModel {
  @attr('number') amountInCents;

  @attr('string') paymentMethod;
  @attr('date') transactionDate;
  @attr('string') memo;

  @attr('date') createdAt;

  @belongsTo('shGeneralInvoice', { async: false }) shGeneralInvoice;

  get amountInDollars() {
    return (this.amountInCents / 100).toFixed(2);
  }
}
